import Vue from "vue";
import Router from "vue-router";
// import Layout from '@/views/layout/layout'
const NormalLayout = resolve => {
  import("@/views/layout/normal-layout.vue").then(module => {
    resolve(module);
  });
};

const Home = resolve => {
  import("@/views/home/home.vue").then(module => {
    resolve(module);
  });
};
// import CourseClassify from '@/views/course-classify/course-classify'
const CourseClassify = resolve => {
  import("@/views/course-classify/course-classify.vue").then(module => {
    resolve(module);
  });
};
// import wapcourseClassify from '@/views/course-classify/wapcourse-classify'
const wapcourseClassify = resolve => {
  import("@/views/course-classify/wapcourse-classify.vue").then(module => {
    resolve(module);
  });
};

// import wapcoursetypeclassify from '@/views/course-classify/wapcourse-typeclassify'
const wapcoursetypeclassify = resolve => {
  import("@/views/course-classify/wapcourse-typeclassify.vue").then(module => {
    resolve(module);
  });
};
// import OrganClassify from '@/views/organ-classify/organ-classify'
const OrganClassify = resolve => {
  import("@/views/organ-classify/organ-classify.vue").then(module => {
    resolve(module);
  });
};
// 成为知识提供者
const merchants = resolve => {
  import("@/views/merchants/merchants.vue").then(module => {
    resolve(module);
  });
};

// 个人
const personmerchants = resolve => {
  import("@/views/merchants/personmerchants.vue").then(module => {
    resolve(module);
  });
};
// 企业
const businessmerchants = resolve => {
  import("@/views/merchants/businessmerchants.vue").then(module => {
    resolve(module);
  });
};

// import BroadcastNav from '@/views/broadcast-nav/broadcast-nav'
const BroadcastNav = resolve => {
  import("@/views/broadcast-nav/broadcast-nav.vue").then(module => {
    resolve(module);
  });
};

// import BroadcastDetails from '@/views/broadcast-details/broadcast-details'
const BroadcastDetails = resolve => {
  import("@/views/broadcast-details/broadcast-details.vue").then(module => {
    resolve(module);
  });
};

// import UserCenter from '@/views/user-center/user-center'
const UserCenter = resolve => {
  import("@/views/user-center/user-center.vue").then(module => {
    resolve(module);
  });
};

// import wapmy-course from '@/views/user-center/wapmy-course'
const wapmycourse = resolve => {
  import("@/views/user-center/wapmy-course.vue").then(module => {
    resolve(module);
  });
};

const wapmycenter = resolve => {
  import("@/views/user-center/wapmy-center.vue").then(module => {
    resolve(module);
  });
};

const wapmyOrder = resolve => {
  import("@/views/user-center/wapmyOrder/wapmy-order.vue").then(module => {
    resolve(module);
  });
};

const wapmyShare = resolve => {
  import("@/views/user-center/wapmyShare/wapmy-share.vue").then(module => {
    resolve(module);
  });
};

const wapmyConfirmOrder = resolve => {
  import("@/views/user-center/wapmyOrder/wapmy-confirm-order.vue").then(
    module => {
      resolve(module);
    }
  );
};

const wapmycenterPerson = resolve => {
  import("@/views/user-center/wapmyComponent/person.vue").then(module => {
    resolve(module);
  });
};

// import phoneUpdute from '@/views/phoneUpdute/phoneUpdute' 修改手机号
const phoneUpdute = resolve => {
  import("@/views/user-center/phoneUpdute.vue").then(module => {
    resolve(module);
  });
};
// import MyCourse from '@/views/user-center/components/my-course/my-course'
const MyCourse = resolve => {
  import("@/views/user-center/components/my-course/my-course.vue").then(
    module => {
      resolve(module);
    }
  );
};

// import MyCollect from '@/views/user-center/components/my-collect/my-collect'
const MyCollect = resolve => {
  import("@/views/user-center/components/my-collect/my-collect.vue").then(
    module => {
      resolve(module);
    }
  );
};

// import MyStudy from '@/views/user-center/components/my-study/my-study'
const MyStudy = resolve => {
  import("@/views/user-center/components/my-study/my-study.vue").then(
    module => {
      resolve(module);
    }
  );
};

// import MyAuth from '@/views/user-center/components/my-auth/my-auth'
const MyAuth = resolve => {
  import("@/views/user-center/components/my-auth/my-auth.vue").then(module => {
    resolve(module);
  });
};

// import MyTest from '@/views/user-center/components/my-test/my-test'
const MyTest = resolve => {
  import("@/views/user-center/components/my-test/my-test.vue").then(module => {
    resolve(module);
  });
};

const MyCode = resolve => {
  import("@/views/user-center/components/my-code/my-code.vue").then(module => {
    resolve(module);
  });
};

// import MyGrowth from '@/views/user-center/components/my-growth/my-growth'
const MyGrowth = resolve => {
  import("@/views/user-center/components/my-growth/my-growth.vue").then(
    module => {
      resolve(module);
    }
  );
};

// import MyOrder from '@/views/user-center/components/my-order/my-order'
const MyOrder = resolve => {
  import("@/views/user-center/components/my-order/my-order.vue").then(
    module => {
      resolve(module);
    }
  );
};

// import MyMess from '@/views/user-center/components/my-mess/my-mess'
const MyMess = resolve => {
  import("@/views/user-center/components/my-mess/my-mess.vue").then(module => {
    resolve(module);
  });
};

// import MyCert from '@/views/user-center/components/my-cert/my-cert'
const MyCert = resolve => {
  import("@/views/user-center/components/my-cert/my-cert.vue").then(module => {
    resolve(module);
  });
};

// import MyData from '@/views/user-center/components/my-data/my-data'
const MyData = resolve => {
  import("@/views/user-center/components/my-data/my-data.vue").then(module => {
    resolve(module);
  });
};
// import TeacherStrength from '@/views/teacher-strength/teacher-strength'
const TeacherStrength = resolve => {
  import("@/views/teacher-strength/teacher-strength.vue").then(module => {
    resolve(module);
  });
};

// import OrganDetails from '@/views/organ-details/organ-details'
const OrganDetails = resolve => {
  import("@/views/organ-details/organ-details.vue").then(module => {
    resolve(module);
  });
};

// import Wrong from '@/views/wrong/wrong.vue'
const Wrong = resolve => {
  import("@/views/wrong/wrong.vue").then(module => {
    resolve(module);
  });
};

// 实现页面的按需加载
const CourseDetails = resolve => {
  // import("@/views/course-details/course-details.vue").then(module => {
  //   resolve(module);
  // });
  import("@/views/course-details-v2/index.vue").then(module => {
    resolve(module);
  });
};
// 实现页面的按需加载
const CourseDetailsForMobile = resolve => {
  import("@/views/course-details/course-details.vue").then(module => {
    resolve(module);
  });
};

// import ChapterDetails from '@/views/chapter-details/chapter-details.vue'
const ChapterDetails = resolve => {
  import("@/views/chapter-details/chapter-details.vue").then(module => {
    resolve(module);
  });
};

// import aboutdownload from '@/views/aboutdownload/aboutdownload'
const aboutdownload = resolve => {
  import("@/views/aboutdownload/aboutdownload.vue").then(module => {
    resolve(module);
  });
};

// import iphonedownload from '@/views/iphonedownload/iphonedownload'
const iphonedownload = resolve => {
  import("@/views/iphonedownload/iphonedownload.vue").then(module => {
    resolve(module);
  });
};
// import aboutus from '@/views/aboutus/aboutus'
const aboutus = resolve => {
  import("@/views/aboutus/aboutus.vue").then(module => {
    resolve(module);
  });
};

// import otheraboutus  from '@/views/aboutus/otheraboutus'
const otheraboutus = resolve => {
  import("@/views/aboutus/otheraboutus.vue").then(module => {
    resolve(module);
  });
};

// import AboutCompany from '@/views/about-company/about-company'
const AboutCompany = resolve => {
  import("@/views/about-company/about-company.vue").then(module => {
    resolve(module);
  });
};

// import ContactUs from '@/views/about-company/components/contact-us'
const ContactUs = resolve => {
  import("@/views/about-company/components/contact-us.vue").then(module => {
    resolve(module);
  });
};

// import AboutUs  from '@/views/about-company/components/about-us'
const AboutUs = resolve => {
  import("@/views/about-company/components/about-us.vue").then(module => {
    resolve(module);
  });
};

// import OrganClass from '@/views/organ-classify/organ-class'
const OrganClass = resolve => {
  import("@/views/organ-classify/organ-class.vue").then(module => {
    resolve(module);
  });
};

// import searchcourse from '@/views/course-classify/searchcourse'
const searchcourse = resolve => {
  import("@/views/searchView/index.vue").then(module => {
    resolve(module);
  });
};

// import wapsearchcourse from '@/views/course-classify/wapsearchcourse'
const wapsearchcourse = resolve => {
  import("@/views/searchView/wapsearchcourse.vue").then(module => {
    resolve(module);
  });
};

// import organcourse from '@/views/course-classify/organcourse'
const organcourse = resolve => {
  import("@/views/course-classify/organcourse.vue").then(module => {
    resolve(module);
  });
};

// import CourseClass from '@/views/course-classify/courseclass'
const CourseClass = resolve => {
  import("@/views/course-classify/courseclass.vue").then(module => {
    resolve(module);
  });
};

// import oderpay from '@/views/oderpay/oderpay'
// const oderpay = (resolve) => {
//   import('@/views/oderpay/oderpay.vue').then((module) => {
//     resolve(module);
//   });
// };

// import paydeail from '@/views/oderpay/paydeail'
const paydeail = resolve => {
  import("@/views/oderpay/paydeail").then(module => {
    resolve(module);
  });
};

// import studyoder from '@/views/oderpay/studyoder'
const studyoder = resolve => {
  import("@/views/oderpay/studyoder").then(module => {
    resolve(module);
  });
};

const LoginRegister = resolve => {
  import("@/views/login-register/index").then(module => {
    resolve(module);
  });
};

const Forgetpassword = resolve => {
  import("@/views/login-register/forgetpassword").then(module => {
    resolve(module);
  });
};

const PaySuccess = resolve => {
  import("@/views/oderpay/pay-success").then(module => {
    resolve(module);
  });
};

// 考试管理
const examination = resolve => {
  import("@/views/examination/examination.vue").then(module => {
    resolve(module);
  });
};

// 考试结果
const exresults = resolve => {
  import("@/views/examination/exresults.vue").then(module => {
    resolve(module);
  });
};

// 推广赚钱
const promote = resolve => {
  import("@/views/promote/promote.vue").then(module => {
    resolve(module);
  });
};

// 我的收益
const myPromote = resolve => {
  import("@/views/promote/my-promote.vue").then(module => {
    resolve(module);
  });
};

// 推广统计
const promoteStats = resolve => {
  import("@/views/promote/promote-stats.vue").then(module => {
    resolve(module);
  });
};

// 收益明细
const promoteIncomeDetail = resolve => {
  import("@/views/promote/income-detail.vue").then(module => {
    resolve(module);
  });
};

const promoteRule = resolve => {
  import("@/views/promote/promote-rule.vue").then(module => {
    resolve(module);
  });
};

const promoteGuide = resolve => {
  import("@/views/promote/promote-guide.vue").then(module => {
    resolve(module);
  });
};
const applyStudy = resolve => {
  import("@/views/apply-study/apply-study.vue").then(module => {
    resolve(module);
  });
};
const applyStudyFlow = resolve => {
  import("@/views/apply-study/apply-study-flow.vue").then(module => {
    resolve(module);
  });
};
const applyStudyResult = resolve => {
  import("@/views/apply-study/apply-study-result.vue").then(module => {
    resolve(module);
  });
};

Vue.use(Router);
export default new Router({
  // mode: 'history',
  routes: [
    {
      path: "",
      name: "布局",
      component: NormalLayout,
      children: [
        {
          path: "",
          name: "首页",
          component: Home
        },
        {
          path: "/CourseClassify",
          name: "课程分类",
          component: CourseClassify
          // authority: 'CourseClassify'
        },
        {
          path: "/wapcourseClassify",
          name: "手机课程分类",
          component: wapcourseClassify
        },
        {
          path: "/wapcoursetypeclassify",
          name: "手机课程二级分类",
          component: wapcoursetypeclassify
        },
        {
          path: "/OrganClassify",
          name: "机构分类",
          component: OrganClassify
        },
        // 以下是6-28日按要求隐藏页面
        // {
        //   path: "/merchants",
        //   name: "成为知识提供者",
        //   component: merchants
        // },
        // {
        //   path: "/personmerchants",
        //   name: "个人入驻",
        //   component: personmerchants
        // },
        // {
        //   path: "/businessmerchants",
        //   name: "企业入驻",
        //   component: businessmerchants
        // },
        {
          path: "/searchcourse",
          name: "查询结果",
          component: searchcourse
        },
        {
          path: "/wapsearchcourse",
          name: "手机端查询结果",
          component: wapsearchcourse
        },
        {
          path: "/organcourse",
          name: "机构相关课程",
          component: organcourse
        },
        {
          path: "/OrganClass",
          name: "推荐机构",
          component: OrganClass
        },
        {
          path: "/CourseClass",
          name: "推荐课程",
          component: CourseClass
        },
        {
          path: "/BroadcastNav",
          name: "最近直播",
          component: BroadcastNav
        },
        {
          path: "/BroadcastDetails",
          name: "直播详情",
          component: BroadcastDetails
        },
        {
          path: "/TeacherStrength",
          name: "师资力量",
          component: TeacherStrength
        },
        // {
        //   path: '/oderpay',
        //   name: '支付页面',
        //   component: oderpay
        // },
        {
          path: "/paydeail",
          name: "支付",
          component: paydeail
        },
        {
          path: "/PaySuccess",
          name: "支付成功",
          component: PaySuccess
        },
        {
          path: "/studyoder",
          name: "加入学习",
          component: studyoder
        },
        {
          path: "/phoneUpdute",
          name: "修改手机号",
          component: phoneUpdute
        },
        {
          path: "/wapmycourse",
          name: "手机端我的课程",
          component: wapmycourse
        },
        {
          path: "/wapmycenter",
          name: "手机端个人中心",
          component: wapmycenter,
          children: [
            {
              path: "person",
              name: "个人信息",
              component: wapmycenterPerson
            }
          ]
        },
        {
          path: "/wapmyOrder",
          name: "手机端订单",
          component: wapmyOrder
        },
        {
          path: "/wapmyConfirmOrder",
          name: "手机端确认订单",
          component: wapmyConfirmOrder
        },
        {
          path: "/wapmyShare",
          name: "手机端分享易极云课堂",
          component: wapmyShare
        },
        {
          path: "/UserCenter",
          name: "个人中心",
          component: UserCenter,
          children: [
            {
              path: "/",
              name: "默认课程选项",
              redirect: "/UserCenter/MyData"
            },
            {
              path: "MyCourse",
              name: "我的课程",
              component: MyCourse
            },
            {
              path: "MyCollect",
              name: "我的收藏",
              component: MyCollect
            },
            {
              path: "MyStudy",
              name: "学习兴趣",
              component: MyStudy
            },
            {
              path: "MyAuth",
              name: "我的认证",
              component: MyAuth
            },
            {
              path: "MyTest",
              name: "我的考试",
              component: MyTest
            },
            {
              path: "MyCode",
              name: "邀请码",
              component: MyCode
            },
            {
              path: "MyGrowth",
              name: "成长记录",
              component: MyGrowth
            },
            {
              path: "MyCert",
              name: "证书查询",
              component: MyCert
            },
            {
              path: "MyOrder",
              name: "我的订单",
              component: MyOrder
            },
            {
              path: "MyMess",
              name: "信息中心",
              component: MyMess
            },
            {
              path: "MyData",
              name: "个人资料",
              component: MyData
            }
          ]
        },
        {
          path: "/OrganDetails",
          name: "机构详情",
          component: OrganDetails
        },

        {
          path: "/CourseDetails",
          name: "课程详情",
          component: CourseDetails
        },
        {
          path: "/CourseDetailsForMobile",
          name: "课程详情",
          component: CourseDetailsForMobile
        },
        // 以下是6-28日按要求隐藏页面
        // {
        //   path: "/aboutdownload",
        //   name: "关于我们",
        //   component: aboutdownload
        // },
        // {
        //   path: "/iphonedownload",
        //   name: "关于我们",
        //   component: iphonedownload
        // },
        // {
        //   path: "/aboutus",
        //   name: "关于我们",
        //   component: aboutus,
        //   meta: {
        //     title: "软考培训_软考考试认证_软考考试时间-易极云课堂"
        //   }
        // },
        // {
        //   path: "/otheraboutus",
        //   name: "关于我们",
        //   component: otheraboutus,
        //   meta: {
        //     title: "软考培训_软考考试认证_软考考试时间-易极云课堂"
        //   }
        // },
        // {
        //   path: "/AboutCompany",
        //   name: "公司相关",
        //   component: AboutCompany,
        //   children: [
        //     {
        //       path: "/",
        //       name: "默认项",
        //       redirect: "/AboutCompany/AboutUs"
        //     },
        //     {
        //       path: "/AboutUs",
        //       name: "关于我们",
        //       component: AboutUs
        //     },
        //     {
        //       path: "/ContactUs",
        //       name: "联系我们",
        //       component: ContactUs
        //     }
        //   ]
        // },
        {
          path: "/examination",
          name: "考试管理",
          component: examination
        },
        {
          path: "/exresults",
          name: "考试结果",
          component: exresults
        },
        {
          path: "/promote",
          component: promote,
          meta: {
            title: "推广赚钱",
            cache: "no-cache, max-age=0"
          }
        },
        {
          path: "/myPromote",
          component: myPromote,
          meta: {
            title: "我的收益",
            cache: "no-cache, max-age=0"
          }
        },
        {
          path: "/promoteStats",
          component: promoteStats,
          meta: {
            title: "推广统计",
            cache: "no-cache, max-age=0"
          }
        },
        {
          path: "/promoteIncomeDetail",
          component: promoteIncomeDetail,
          meta: {
            title: "收益明细",
            cache: "no-cache, max-age=0"
          }
        },
        {
          path: "/promoteRule",
          component: promoteRule,
          meta: {
            title: "规则说明",
            cache: "max-age=60"
          }
        },
        {
          path: "/promoteGuide",
          component: promoteGuide,
          meta: {
            title: "课程分销指南"
          }
        },
        {
          path: "/applyStudy",
          component: applyStudy,
          meta: {
            title: "报名学习"
          }
        },
        {
          path: "/applyStudyFlow",
          component: applyStudyFlow,
          meta: {
            title: "报名学习流程"
          }
        },
        {
          path: "/applyStudyResult",
          component: applyStudyResult,
          meta: {
            title: "报名完成结果页面"
          }
        }
      ]
    },
    {
      path: "/ChapterDetails",
      name: "课程播放",
      component: ChapterDetails
    },
    {
      path: "/Login",
      name: "登录",
      component: LoginRegister
    },
    {
      path: "/Forget",
      name: "忘记密码",
      component: Forgetpassword
    },
    {
      path: "*",
      redirect: "/Wrong"
    },
    {
      path: "/Wrong",
      name: "404页面",
      component: Wrong
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js